import './App.css';
import MainPage from "./components/organisms/main"

function App() {
  return (
    <div className="App">
      <MainPage />
    </div>
  );
}

export default App;
